import { render, staticRenderFns } from "./MyCourseDetail.vue?vue&type=template&id=bddbed78&scoped=true"
import script from "./MyCourseDetail.vue?vue&type=script&lang=js"
export * from "./MyCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./MyCourseDetail.vue?vue&type=style&index=0&id=bddbed78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddbed78",
  null
  
)

export default component.exports